<script setup>
import { computed } from 'vue'
import { gApp } from '../State.js'

let isAdmin = computed(() => {
  return gApp.isAdminUser();
})
</script>

<template>
  <div v-if="isAdmin" class="AdminOnly">
    <slot></slot>
  </div>
</template>

<style scoped>
.AdminOnly {
  outline: 1px solid red;
  padding: 0px;
}
</style>
